import { render, staticRenderFns } from "./FileShareModal.vue?vue&type=template&id=f2296cba"
import script from "./FileShareModal.vue?vue&type=script&lang=js"
export * from "./FileShareModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports